<template>
  <!-- 历程类数据的统一组件 -->
  <div class="box-drawer">
    <el-drawer v-model="showHistory" :title="title" class="customer-history">
      <div class="timeline-box">
        <el-timeline style="width: 94%">
          <el-timeline-item v-for="it in dataList" :key="it.id" :timestamp="it.operateTime" placement="top" :color="getColor(it.colorIndex || 3)">
            <div class="row-header">
              <slot name="name" :row="it">{{headerName}}</slot> <!-- 显示在头上的信息，历程分类，比如加入公司，离职 -->
            </div>
            <div class="row-desc">
              <slot name="info" :row="it">{{it.desc}}</slot>
            </div>
            <div class="row-option">
              <slot name="option" :row="it">{{it.operatorName}}</slot>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";

export default {
  props: {
    title: {default: ""},
    headerName: {default: ""},
    dataList: {default: () => []},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "DH",
  components: {
  },
  data() {
    return {
      showHistory: false,
    };
  },
  created() {
  },
  methods: {
    // 显示历程数据
    showData() {
      this.showHistory = true;
    },
    // 历程数据的颜色
    getColor(type) {
      type = Number(type)
      switch (type) {
        case 1:
          return '#FF4D4F'  // 红色 - 玫瑰红
        case 2:
          return '#52C41A'  // 绿色 - 翠绿
        case 3:
          return '#1890FF'  // 蓝色 - 天蓝
        case 4:
          return '#FAAD14'  // 黄色 - 金盏花黄
        case 5:
          return '#FA8C16'  // 橙色 - 橙红
        case 6:
          return '#722ED1'  // 紫色 - 紫罗兰
        case 7:
          return '#EB2F96'  // 粉色 - 品红
        case 8:
          return '#13C2C2'  // 青色 - 孔雀蓝
        case 9:
          return '#EB2F96'  // 玫红色 - 洋红
        case 10:
          return '#76f6ae'  // 浅绿色
        default:
          return '#000000'  // 黑色
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.box-drawer{
  :deep(.el-drawer) {
    .el-drawer__title{
      font-size: 20px;
    }
  }
  .row-header{
    font-size: 16px;
    font-weight: 600;

  }
  .row-desc{
    margin: 10px 0;
  }
  .row-option{
    font-size: 12px;
  }
}
</style>